import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Tengo que comprar suplementos caros?',
    a: 'No. El 90% del protocolo se basa en temperatura, luz y sincronización de comidas.'
  }, {
    q: '¿Funciona si llevo años con insomnio?',
    a: "Sí, porque no apelamos a tu 'fuerza de voluntad', sino a tu biología circadiana que sigue ahí, solo que desajustada."
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-800" data-id="element-17">
      <div className="max-w-3xl mx-auto" data-id="element-18">
        <FadeIn data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-20">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-21">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} delay={index * 0.1} data-id="element-22" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  delay
}: {
  question: string;
  answer: string;
  delay: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <FadeIn delay={delay} data-id="element-23">
      <div className="border border-navy-700 bg-navy-900 rounded-xl overflow-hidden" data-id="element-24">
        <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-25">
          <span className="font-bold text-lg text-white" data-id="element-26">{question}</span>
          <motion.div animate={{
          rotate: isOpen ? 180 : 0
        }} transition={{
          duration: 0.2
        }} data-id="element-27">
            <ChevronDown className="text-amber-500" data-id="element-28" />
          </motion.div>
        </button>
        <AnimatePresence data-id="element-29">
          {isOpen && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-30">
              <div className="px-6 pb-5 text-lavender-200" data-id="element-31">{answer}</div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </FadeIn>;
}